/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')

/**
 * Register Components
 */
import { createApp, onMounted } from 'vue'

// Modals
import InfoModal from './components/modals/InfoModal.vue'
import ProductModal from './components/modals/ProductModal.vue'
import WatchDogModal from './components/modals/WatchDogModal.vue'

// Forms
import SearchForm from './components/forms/SearchForm.vue'

//Carousels
import ProductDetailCarousel from './components/carousels/ProductDetailCarousel.vue'

// Buttons
import AddToCart from './components/buttons/AddToCart.vue'
import WatchDog from './components/buttons/WatchDog.vue'

// Inputs
import QuantityInput from './components/inputs/QuantityInput.vue'
import ZipInput from './components/inputs/ZipInput.vue'
import CityInput from './components/inputs/CityInput.vue'

// Utils
import ProductListing from './components/product/listing/ProductListing.vue'
import Loader from './components/globals/Loader.vue'
import CartCount from './components/globals/CartCount.vue'

// Products
import ProductDataWrap from './components/product/detail/ProductDataWrap.vue'

/**
 * Register Plugins
 */
import Toast, { POSITION  } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import VueFinalModal from 'vue-final-modal'
import VueSvgInlinePlugin from 'vue-svg-inline-plugin'
import mitt from 'mitt'
const emitter = mitt()

/**
 * Composables
 */
import { useGtm } from './composables/useGtm'
import Gtm from './components/gtm/Gtm.vue'

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

/**
 * Plugins Options
 */
const toastOptions = {
    position: POSITION.BOTTOM_RIGHT,
    timeout: false
}

const app = createApp({

    components: {
        InfoModal,
        ProductListing,
        SearchForm,
        AddToCart,
        Loader,
        QuantityInput,
        ProductModal,
        CartCount,
        CityInput,
        ZipInput,
        WatchDogModal,
        WatchDog,
        ProductDetailCarousel,
        ProductDataWrap,
        Gtm
    },

    setup() {

        const { trackEvent } = useGtm()

        onMounted( () => {
            emitter.on('track-event', (payload) => {
                trackEvent(payload.data, payload.event, payload.user)
            })
        })
    }
})

app.use(VueFinalModal())
    .use(Toast, toastOptions)
    .use(VueSvgInlinePlugin)
    .provide('emitter', emitter)

app.mount('#app')

